import en from "./en";
import ru from "./ru";
import pt from "./pt";
export { type Translations } from "./types";

export const translations = { ru, en, pt };
